import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bc9cebaa&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bc9cebaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9cebaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc9cebaa')) {
      api.createRecord('bc9cebaa', component.options)
    } else {
      api.reload('bc9cebaa', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bc9cebaa&scoped=true&", function () {
      api.rerender('bc9cebaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22J9akXhfqEUQ/JS/comp/DocBox.vue"
export default component.exports